import { Field, useFormikContext } from "formik";
import React from "react";
import { StyledTextField } from "./styled-components/AddressFields";
import { FormValues } from "./utils/formSchema";
import { StyledEndAdorment } from "./AddressLookup";
import { useAppDispatch } from "src/store/store";
import { setPreferredName } from "src/store/features/onboarding.slice";

export default function PreferredNameField() {
  const dispatch = useAppDispatch();

  const {
    values: { preferredName },
    errors: { preferredName: preferredNameError },
  } = useFormikContext<FormValues>();

  return (
    <Field
      name="preferredName"
      as={StyledTextField}
      selected={!!preferredName}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        dispatch(setPreferredName(event.target.value))
      }
      InputProps={{
        endAdornment: <StyledEndAdorment selected={!!preferredName} />,
        inputProps: { maxLength: 50 },
      }}
      error={!!preferredNameError}
      helperText={preferredNameError}
    />
  );
}
